import {ActionWithPayload} from '../../helpers/reduxHelpers';
import {FeatureFlagsMap} from './featureFlagsState';

/*
 * Action types.
 */

export enum FeatureFlagsActionsEnum {
  UPDATE = '@@featureFlags/UPDATE',
}

/*
 * Types.
 */

interface UpdateAction extends ActionWithPayload<FeatureFlagsMap> {
  type: FeatureFlagsActionsEnum.UPDATE;
}

export type FeatureFlagsAction = UpdateAction;

/*
 * Action creators.
 */

export function updateFeatureFlags(newFeatureFlags: FeatureFlagsMap): UpdateAction {
  return {
    type: FeatureFlagsActionsEnum.UPDATE,
    payload: newFeatureFlags,
  };
}
